import EfLink from '@elem/ui/ef-link';
import EcoBlogCard from 'eco-design/sections/eco-blog-items/eco-blog-card';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import { queryCategoryItems } from '../../common/blog-api/queryCategoryItems';
import { LangText } from '../../common/blog-lang-text';
import BlogTimer from '../../common/blog-timer';
import { getBlogTagFromList } from '../../common/utils';
import EcoLink from 'eco-design/base/eco-link';
import EcoImgVideo from 'eco-design/base/eco-img-video';

export default function Content({ id, data }: any) {
    const { categoryId, categoryName, items = [] } = data;
    const { locale = 'us' } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const categoryHref = `/${locale}/blog/category/${categoryId}`;
    const [categoryNameA, setCategoryNameA] = useState(categoryName);
    const items2 = items.slice(0, 4);
    const [itemsA, setItemsA] = useState(items2);
    useEffect(() => {
        const getItemsForNone = async () => {
            const dataA = await queryCategoryItems(locale, {
                categoryId: categoryId,
            });
            setCategoryNameA(dataA?.categoryName);
            const itemsB2 = (dataA.items || []).slice(0, 4);
            setItemsA(itemsB2);
        };
        if (items2.length === 0 && categoryId) {
            getItemsForNone();
        }
    }, [categoryId, items2.length]);

    return (
        <GloLayout className="editor-blog-category-c" id={id}>
            <div className="editor-blog-category-c-h">
                <h2 className="editor-blog-category-c-h-l">{categoryNameA}</h2>
                <div className="editor-blog-category-c-h-r">
                    <EfLink href={categoryHref} className="editor-blog-category-c-h-btn">
                        {TextA.ViewAll}
                    </EfLink>
                </div>
            </div>
            <div className="editor-blog-category-c-c">
                {itemsA?.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], categoryId);
                    return (
                        <Fragment key={index}>
                            <EcoBlogCard
                                label={tagItem.tag}
                                title={thePage.blogTitle}
                                pc={thePage.blogImgPc}
                                h5={thePage.blogImgH5}
                                href={item.seoUrl}
                                categoryHref={`/${locale}/blog/category/${categoryId}`}
                                timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                            />
                        </Fragment>
                    );
                })}
            </div>
        </GloLayout>
    );
}

